import api from './AxiosInstance';
import printJS from "print-js";
import { api_URL } from "./Constantes";

export class GestionPaieService {

  openMensuel = async (payload) => {
    try {
      const response = await api.post(`/Paie/Bulletins/Open`, payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  closeMensuel = async (payload) => {
    try {
      const response = await api.put(`/Paie/Bulletins/Close?numParam=param1`, payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      throw error;
    }
  };


  getBullRubCal = async (numbull) => {
    try {
      const response = await api.get(`/Paie/Bulletins/Calcul/list?numbull=${numbull}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  addBullRub = async (payload) => {
    try {
      const response = await api.post(`/Paie/BullRub/add`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  addSalaries = async (payload) => {
    try {
      const response = await api.post(`/Paie/Salaries/add`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  upDataSalaries = async (payload) => {
    try {
      const response = await api.put(`/Paie/Salaries/update`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllSalaries = async () => {
    try {
      const response = await api.get(`/Paie/Salaries/list?perim=IPM`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getAllBulletins = async () => {
    try {
      const response = await api.get(`/Paie/Bulletins/list?perim=IPM`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  ///Paie/RubriquesSaisie/list?numbull=617&matrisal=XXXX
  getRubriquesSaisie = async (numbull, matrisal) => {
    try {
      const response = await api.get(`/Paie/RubriquesSaisie/list?numbull=${numbull}&matrisal=${matrisal}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getDuplicata = async () => {
    try {
      const response = await api.get(`/Paie/Salaries/list?perim=IPM`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getConvention = async () => {
    try {
      const response = await api.get(`/Paie/Conventions/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getCateg = async () => {
    try {
      const response = await api.get(`/Paie/Categories/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getAllModelisation = async () => {
    try {
      const response = await api.get(`/Paie/ModCompta/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  ///Paie/Pret/stopped (put)
  putpret = async () => {
    try {
      const response = await api.put(`Paie/Pret/stopped`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getAllRubriques = async () => {
    try {
      const response = await api.get(`/Paie/Rubriques/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllCompta = async () => {
    try {
      const response = await api.get(`/PlanCompta/listAll`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllConv = async () => {
    try {
      const response = await api.get(`/Paie/Conventions/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllCategorie = async () => {
    try {
      const response = await api.get(`/Paie/Categories/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllTypePrets = async () => {
    try {
      const response = await api.get(`/Paie/Pret/Type/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  //
  updateModelisation = async (payload) => {
    try {
      const response = await api.put(`/Paie/ModCompta/update`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  updateRubriques = async (payload) => {
    try {
      const response = await api.put(`/Paie/Rubriques/update`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  updateConv = async (payload) => {
    try {
      const response = await api.put(`/Paie/Conventions/update`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  updateCateg = async (payload) => {
    try {
      const response = await api.put(`/Paie/Categories/update`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  updateTypePrets = async (payload) => {
    try {
      const response = await api.put(`/Paie/Pret/Type/update`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  ///Paie/Categories/list

  addModelisation = async (payload) => {
    try {
      const response = await api.post(`/Paie/ModCompta/add`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  addRubriques = async (payload) => {
    try {
      const response = await api.post(`/Paie/Rubriques/add`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  addConv = async (payload) => {
    try {
      const response = await api.post(`/Paie/Conventions/add`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  addCateg = async (payload) => {
    try {
      const response = await api.post(`/Paie/Categories/add`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  addTypePrets = async (payload) => {
    try {
      const response = await api.post(`/Paie/Pret/Type/add`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  //

  deleteModelisation = async (compte, rubrique) => {
    try {
      const response = await api.delete(`/Paie/ModCompta/delete/${compte}/${rubrique}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  deleteRubrique = async (code) => {
    try {
      const response = await api.delete(`/Paie/Rubriques/delete/${code}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  deleteConv = async (codeconv) => {
    try {
      const response = await api.delete(`/Paie/Conventions/delete/${codeconv}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  deleteCateg = async (codecateg) => {
    try {
      const response = await api.delete(`/Paie/Categories/delete/${codecateg}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  deleteTypePrets = async (code) => {
    try {
      const response = await api.delete(`/Paie/Type/Pret/delete/${code}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  deletePaie = async (numbull) => {
    try {
      const response = await api.delete(`/Paie/Bulletins/${numbull}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getPeriod = async (matricule) => {
    try {
      const response = await api.get(`/Paie/Salaries/Bull/DateFin?matrisal=${matricule}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  clotureMensuel = async (param1) => {
    try {
      const response = await api.put(`Close?numParam=${param1}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  //Close?numParam=param1
  addPassation = async (datedeb, datefin) => {
    try {
      const response = await api.post(`/Compta/PreviewComptaSalaire`, {
        datedeb: datedeb,
        datefin: datefin
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  addcomptabilis = async (payload) => {
    try {
      const response = await api.post(`/Compta/ValidPreviewCompta/Salaire`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };



  printBulletinsService = (numbull) => {
    const url = `${api_URL}/Print/BulletinIndiv/${numbull}?docName=BulletinIndiv`;

    fetch(url, {
      method: 'GET',
      /*  headers: {
         'user_id': 'xxxx',
         'username': 'xxxx',  
       }, */
    })
      .then(response => response.blob())
      .then(blob => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);

        // Utilisez printJS pour imprimer le PDF
        printJS(fileURL);
      })
      .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };

  printBulletins = () => {
    const url = `${api_URL}/Print/Bulletins/Bulletins`;

    fetch(url, {
      method: 'GET',
      /*   headers: {
          'user_id': 'xxxx',
          'username': 'xxxx',  
        }, */
    })
      .then(response => response.blob())
      .then(blob => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);

        // Utilisez printJS pour imprimer le PDF
        printJS(fileURL);
      })
      .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };

  printVirementSalaire = () => {
    const url = `${api_URL}/Print/Bulletins/Virement_Salaire`;

    fetch(url, {
      method: 'GET',
      /*  headers: {
         'user_id': 'xxxx',
         'username': 'xxxx',  
       }, */
    })
      .then(response => response.blob())
      .then(blob => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);

        // Utilisez printJS pour imprimer le PDF
        printJS(fileURL);
      })
      .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };

  printLettreChequeSAL = () => {
    const url = `${api_URL}/Print/Bulletins/Lettre_Cheque_SAL`;

    fetch(url, {
      method: 'GET',
      /* headers: {
        'user_id': 'xxxx',
        'username': 'xxxx',  
      }, */
    })
      .then(response => response.blob())
      .then(blob => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);

        // Utilisez printJS pour imprimer le PDF
        printJS(fileURL);
      })
      .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };

  printCotisations = () => {
    const url = `${api_URL}/Print/Bulletins/Cotisations`;

    fetch(url, {
      method: 'GET',
      /*  headers: {
         'user_id': 'xxxx',
         'username': 'xxxx',  
       }, */
    })
      .then(response => response.blob())
      .then(blob => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);

        // Utilisez printJS pour imprimer le PDF
        printJS(fileURL);
      })
      .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };

  printPassationModal = () => {
    const url = `${api_URL}/Print/Exports/Tab/OD_Salaire`;

    fetch(url, {
      method: 'GET',
      /*  headers: {
         'user_id': 'xxxx',
         'username': 'xxxx',  
       }, */
    })
      .then(response => response.blob())
      .then(blob => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);

        // Utilisez printJS pour imprimer le PDF
        printJS(fileURL);
      })
      .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };

  printBulletinIndiv = (matricule, fin) => {
    const url = `${api_URL}/Print/BulletinIndiv/${matricule}/${fin}`;

    fetch(url, {
      method: 'GET',
      /*  headers: {
         'user_id': 'xxxx',
         'username': 'xxxx',  
       }, */
    })
      .then(response => response.blob())
      .then(blob => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);

        // Utilisez printJS pour imprimer le PDF
        printJS(fileURL);
      })
      .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };


}


